<h6 class="ft17 ft500 mgb20">Datos de facturación</h6>

<div class="mgt10">
    <label>Razón social</label>
    <input type="text" [(ngModel)]="datosFact.razonSocial" [ngModelOptions]="{standalone: true}" class="fw">
</div>

<div class="mgt10">
    <label>Número de identificación fiscal</label>
    <input type="text" [(ngModel)]="datosFact.nif" [ngModelOptions]="{standalone: true}" class="fw">
</div>

<div class="mgt10">
    <label>Dirección fiscal</label>
    <input type="text" [(ngModel)]="datosFact.cp" [ngModelOptions]="{standalone: true}" class="fw">
</div>

<div class="mgt10">
    <label>Código Postal</label>
    <input type="text" [(ngModel)]="datosFact.direccion" [ngModelOptions]="{standalone: true}" class="fw">
</div>

<div class="mgt10">
    <label>País</label>
    <input type="text" [(ngModel)]="datosFact.pais" [ngModelOptions]="{standalone: true}" class="fw">
</div>

<div class="mgt10">
    <label>Correo electrónico</label>
    <input type="text" [(ngModel)]="datosFact.email" [ngModelOptions]="{standalone: true}" class="fw">
</div>

<div class="mgt10">
    <label>Teléfono</label>
    <input type="text" [(ngModel)]="datosFact.tlf" [ngModelOptions]="{standalone: true}" class="fw">
</div>

<div class="mgt10">
    <button class="darkButton" (click)="guardarDatosFact()">Guardar</button>
</div>
